import useSWRImmutable from 'swr/immutable';
import capsFetcher from '../../shared/capsFetcher';

const useMerchants = (id, options = {}) => useSWRImmutable(id ? { url: `/dealerships/${id}` } : null, capsFetcher, options);

export default useMerchants;
